import {mapState} from 'vuex'

export default {
    name: 'AccountInformation',
    data() {
        return {
        }
    },
    methods: {
    },
    computed: {
        ...mapState({
            user: state => state.account.user
        }),
    },
    created() {
        this.$store.dispatch('account/getUser');
    }
}